import store from '@/store';
import { VDataTable } from 'vuetify/labs/VDataTable';
import QuestionDataService from './services/QuestionDataService';
import { sanitizeHtml } from '@/assets/js/common/sanitize';

export default {

    name: 'Questionario',
    components: { VDataTable },

    data: () => ({
        alert: false,
        alertText: '',
        alertType: null,
        deletingRepositoryQuestion: false,
        dialog: false,
        dialogDelete: false,
        headers: [
            { title: 'Questao', key: 'question', align: 'start', width: '68%' },
            { title: 'Dificuldade', key: 'difficulty', align: 'center', width: '12%' },
            { title: 'Qtd. de Alternativas', key: 'answers.length', align: 'center', width: '10%' },
            { title: 'Acoes', key: 'actions', align: 'center', sortable: false, width: '10%' },
        ],
        listQuestions: [],
        loading: true,
        loadingSave: false,
        name: '',
        questionToDelete: null,
        selectedQuestions: [],
        requiredField: [v => !!v || 'O campo e obrigatorio.'],
        sbColor: 'success',
        sbMessage: '',
        snackbar: false,
    }),

    mounted() {
        this.getQuestionsAll();
    },

    watch: {
        alert(newVal) {
            if (newVal) {
                setTimeout(() => { this.alert = false; }, 5000);
            }
        },
    },

    methods: {
        sanitizeHtml,

        closeDelete() {
            this.dialogDelete = false;
            this.questionToDelete = null;
        },

        closeDialog() {
            this.dialog = false;
        },

        createQuestions() {
            const perguntas = this.listQuestions.filter(item => this.selectedQuestions.includes(item.id));
            if (this.selectedQuestions.length === 0) {
                this.sbColor = 'error';
                this.sbMessage = 'Selecione ao menos uma pergunta!';
                this.snackbar = true;
            } else if (perguntas.every((pergunta, index, array) => pergunta.answers.length === array[0].answers.length)) {
                this.dialog = true;
            } else {
                this.sbColor = 'error';
                this.sbMessage = 'So e permitido selecionar perguntas com a mesma quantidade de alternativas!';
                this.snackbar = true;
            }
        },

        askDeleteQuestion(item) {
            this.questionToDelete = item;
            this.dialogDelete = true;
        },

        async deleteRepositoryQuestionConfirm() {
            if (!this.questionToDelete) {
                return;
            }

            this.deletingRepositoryQuestion = true;

            await QuestionDataService.deleteFromRepository({
                repositoryKey: this.questionToDelete.repositoryKey,
                question: this.questionToDelete.question,
            }).then(() => {
                this.sbColor = 'success';
                this.sbMessage = 'A questao foi removida do repositorio. As avaliacoes ja criadas nao foram alteradas.';
                this.selectedQuestions = this.selectedQuestions.filter(id => id !== this.questionToDelete.id);
            }).catch(error => {
                this.sbColor = 'error';
                this.sbMessage = error.response?.data?.error || 'Erro ao remover a questao do repositorio!';
            });

            this.snackbar = true;
            await this.getQuestionsAll();
            this.deletingRepositoryQuestion = false;
            this.closeDelete();
        },

        async getQuestionsAll() {
            this.loading = true;
            await QuestionDataService.listAll().then(response => {
                this.listQuestions = response.data;
            }).catch(error => {
                console.log(error);
            });
            this.loading = false;
        },

        limitString(str, limit) {
            if (str.length > limit) {
                return str.slice(0, limit) + '...';
            }
            return str;
        },

        async onSubmit() {
            this.loadingSave = true;
            const { valid } = await this.$refs.form.validate();
            if (valid) {
                const perguntas = this.listQuestions.filter(item => this.selectedQuestions.includes(item.id));
                const perguntasFormatoNovo = perguntas.map(item => ({
                    altTrue: item.altTrue,
                    answers: item.answers,
                    difficulty: item.difficulty || '3',
                    question: item.question,
                }));
                await QuestionDataService.create({
                    usuario: store.state.userId,
                    nome: this.name,
                    perguntas: perguntasFormatoNovo,
                }).then(() => {
                    this.dialog = false;
                    this.sbColor = 'success';
                    this.sbMessage = 'O questionario foi criado!';
                }).catch(error => {
                    this.alertType = 'error';
                    this.alertText = error.response.data.error;
                    this.sbColor = this.alertType;
                    this.sbMessage = this.alertText;
                    this.alert = true;
                });
                this.$refs.form.reset();
                this.selectedQuestions = [];
                this.snackbar = true;
            }
            this.loadingSave = false;
        },
    },
};
